var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStore } from "@context/store";
import { useUI } from "@context/ui";
import { Field, Formik } from "formik";
import { FormStateProvider, useFormState } from "./context";
import InputField from "../InputField";
import ZipCodeField from "./ZipCodeField";
import { ConfirmButton, initialValues as ZipInitial } from "./ZipCodeForm";
import { ADDRESS_SCHEMA } from "@schema/index";
var initialValues = __assign({ first_name: "", last_name: "", address1: "", address2: "", city: "", company: "", phone: "", province: "" }, ZipInitial);
var AddressForm = function () {
    var locations = useFormState().locations;
    var _a = useStore(), setAddress = _a.setAddress, setLocation = _a.setLocation, address = _a.address;
    var nextStep = useUI().nextStep;
    var onSubmit = function (values) {
        if (locations) {
            setLocation(__assign({}, locations[0]));
            setAddress(values);
            nextStep();
        }
    };
    var values = __assign(__assign({}, initialValues), address);
    return (_jsx(Formik, __assign({ initialValues: values, validationSchema: ADDRESS_SCHEMA, onSubmit: onSubmit }, { children: function (_a) {
            var handleSubmit = _a.handleSubmit;
            return (_jsx("form", __assign({ onSubmit: handleSubmit, autoComplete: "off" }, { children: _jsxs("div", __assign({ className: "max-w-sm" }, { children: [_jsxs("div", __assign({ className: "flex space-x-2 w-full" }, { children: [_jsx(Field, { className: "flex-1", type: "text", name: "first_name", placeholder: "First name", component: InputField }, void 0),
                                _jsx(Field, { className: "flex-1", type: "text", name: "last_name", placeholder: "Last name", component: InputField }, void 0)] }), void 0),
                        _jsx(Field, { type: "text", name: "address1", placeholder: "Address 1", component: InputField }, void 0),
                        _jsx(Field, { type: "text", name: "address2", placeholder: "Address 2", component: InputField }, void 0),
                        _jsx(Field, { type: "text", name: "company", placeholder: "Company", component: InputField }, void 0),
                        _jsxs("div", __assign({ className: "flex space-x-2 w-full" }, { children: [_jsx(ZipCodeField, { className: "flex-1" }, void 0),
                                _jsx(Field, { className: "flex-1", type: "text", name: "city", placeholder: "City", component: InputField }, void 0)] }), void 0),
                        _jsxs("div", __assign({ className: "flex space-x-2 w-full" }, { children: [_jsx(Field, { className: "flex-1", type: "text", name: "country", placeholder: "Country", component: InputField }, void 0),
                                _jsx(Field, { className: "flex-1", type: "text", name: "province", placeholder: "Province", component: InputField }, void 0)] }), void 0),
                        _jsx(Field, { type: "text", name: "phone", placeholder: "Phone", component: InputField }, void 0),
                        _jsx(ConfirmButton, {}, void 0)] }), void 0) }), void 0));
        } }), void 0));
};
var AddressFormWithContext = function (props) {
    return (_jsx(FormStateProvider, { children: _jsx(AddressForm, __assign({}, props), void 0) }, void 0));
};
export default AddressFormWithContext;
